import React from "react";

export function Logo({ size = "md" }) {
  const map = { sm: "text-xl", md: "text-2xl", lg: "text-4xl" };
  return (
    <div className="flex items-center gap-2 select-none" data-testid="ob-logo">
      <div className="relative">
        <span className={`font-num font-extrabold ${map[size]} text-[#00E5FF] tracking-tight`}>OB</span>
      </div>
      <span className={`font-num font-light ${size === "lg" ? "text-2xl" : "text-base"} tracking-[0.35em] text-white`}>PAY</span>
    </div>
  );
}
